var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16675 2.33332C2.94573 2.33332 2.73377 2.42112 2.57749 2.5774C2.42121 2.73368 2.33341 2.94564 2.33341 3.16666V14.8333C2.33341 15.0543 2.42121 15.2663 2.57749 15.4226C2.73377 15.5789 2.94573 15.6667 3.16675 15.6667H6.50008C6.96032 15.6667 7.33341 16.0398 7.33341 16.5C7.33341 16.9602 6.96032 17.3333 6.50008 17.3333H3.16675C2.50371 17.3333 1.86782 17.0699 1.39898 16.6011C0.93014 16.1322 0.666748 15.4964 0.666748 14.8333V3.16666C0.666748 2.50362 0.93014 1.86773 1.39898 1.39889C1.86782 0.930048 2.50371 0.666656 3.16675 0.666656H6.50008C6.96032 0.666656 7.33341 1.03975 7.33341 1.49999C7.33341 1.96023 6.96032 2.33332 6.50008 2.33332H3.16675Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7442 4.24407C12.0696 3.91863 12.5972 3.91863 12.9227 4.24407L17.0893 8.41073C17.4148 8.73617 17.4148 9.26381 17.0893 9.58924L12.9227 13.7559C12.5972 14.0813 12.0696 14.0813 11.7442 13.7559C11.4187 13.4305 11.4187 12.9028 11.7442 12.5774L14.4882 9.83332H6.44056C6.01319 9.83332 5.66675 9.46023 5.66675 8.99999C5.66675 8.53975 6.01319 8.16666 6.44056 8.16666H14.4882L11.7442 5.42258C11.4187 5.09714 11.4187 4.5695 11.7442 4.24407Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.78900206d687b18d7a336210e890a74a.svg";
export { ForwardRef as ReactComponent };